<script setup>
import { computed } from "vue";

const props = defineProps({
  width: Number,
  source: String,
  hint: String,
  classes: String,
  sprite: Boolean,
  spritePos: { type: String, default: "0%" }, // can be '0%', '50%', '100%' or pixel values
});
const emit = defineEmits(["ontap"]);

function onTap() {
  console.log("image logo ontap");
  emit("ontap");
}

const spriteStyle = computed(() => ({
  backgroundImage: `url(${props.source})`,
  backgroundSize: "auto 100%",
  backgroundPosition: `${props.spritePos} center`,
  backgroundRepeat: "no-repeat",
}));
</script>

<template>
  <div
    v-if="props.sprite"
    class="logo-sprite cursor-pointer"
    :class="props.classes"
    :style="spriteStyle"
    @click.stop="onTap"
  ></div>
  <img
    v-else
    :width="props.width ?? 180"
    :src="props.source"
    :alt="props.hint ?? 'image_logo'"
    :class="props.classes"
    :title="props.hint"
    @click.stop="onTap"
  />
</template>

<style scoped>
.logo-sprite {
  display: block;
}
img {
  cursor: pointer;
}

@media screen and (max-width: 500px) {
  img {
    width: 80px;
  }
}

@media screen and (max-width: 320px) {
  img {
    width: 60px;
  }
}
</style>
